import gql from 'graphql-tag';

export const GET_INVOICE = gql`
  query Invoice($id: ID!) {
    invoice: vendorOpportunity(id: $id) {
      downPayment
      invoiceTotal
      equipmentCost
      salesTaxOnInvoice
      tradeOwedBalanceAmount
      freightLaborInstallation
      manufacturerRebateAmount
      tradeAllowanceGrossTradeIn
      invoiceWarrantyAndInsuranceCharges
    }
  }
`;
